export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_19.28bd173c.jpg";